// A tiny wrapper around fetch(), borrowed from
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper

//needed: bring over headers from old postsActions.js and logic from surgical_focus form creator
export async function client(endpoint, mediaUpld = null, formData = null, { body, ...customConfig } = {}) {
    let apiHeaders = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': 'http://192.168.1.74:8015',
        //AUTH use bearer token
    }
    let formHeaders = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': 'http://192.168.1.74:8015',
    }
    let mediaUpldHeaders = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': 'http://192.168.1.74:8015'
    }
    //console.log(`mediaUpld value: \n\n ${mediaUpld}`)
    let headers = mediaUpld == null ? apiHeaders : mediaUpldHeaders;
    headers = formData == null ? headers : formHeaders;
    //console.log(`value of body:\n ${Object.values(body)} and headers: ${Object.values(headers)}`)
    console.log(`body value: ${body}\nform_data value: ${formData}`)
    //descript: config assembly area
    let postConfig = {
        method: 'POST',
        body: body,
        mode: 'cors',
        credentials: 'include',
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
        },
    }
    let getConfig = {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers,
        },
    }
    
    let config = body != null ? postConfig : getConfig
    //console.log(`config area: ${Object.values(config)}`)
    let data
    try {
        const response = await window.fetch(endpoint, config)
        data = await response.json()
        if (response.ok) {
            return data
        }
            throw new Error(response.statusText)
    } catch (err) {
        return Promise.reject(err.message ? err.message : data)
    }
}

client.get = function (endpoint, customConfig = {}) {
    console.log('client get');
    return client(endpoint, { ...customConfig, method: 'GET' })
}

client.post = function (endpoint, body, customConfig = {}) {
    //console.log('in client post method')
    return client(endpoint, null, null, { ...customConfig, body })
}

client.postFormData = function (endpoint, body, formData, customConfig = {}) {
    console.log('in client postForm method')
    return client(endpoint, null, true,{ ...customConfig, body })
}

client.uploadMedia = function (endpoint, mediaUpload, body, customConfig = {}) {
    console.log(mediaUpload);
    return client(endpoint, mediaUpload, { ...customConfig, body })
}

client.grabBlob = function(endpoint, mediaUpload, body, customConfig = {}) {
    
    //console.log(body.getAll());
    return client(endpoint, mediaUpload, { ...customConfig, body })
}
//needed:handle file uploads(reference mdn) a different file(ServiceWorker) to push up all the files
//needed:service worker to start pushing
